import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6c73fac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-notification-message-form-wrapper" }
const _hoisted_2 = { class: "field grid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "title",
  class: "col-12 required"
}, "タイトル", -1))
const _hoisted_4 = { class: "lg:col-4 md:col-12 sm:col-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "note" }, "タイトルはLINEユーザーには表示されません。", -1))
const _hoisted_6 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_7 = { class: "field grid" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "title",
  class: "col-12"
}, "メッセージの種類", -1))
const _hoisted_9 = { class: "lg:col-3 md:col-4 sm:col-6" }
const _hoisted_10 = { class: "field grid" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "content",
  class: "col-12 required"
}, "メッセージ", -1))
const _hoisted_12 = { class: "lg:col-8 md:col-12 sm:col-12 h-auto mb-2" }
const _hoisted_13 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_14 = { class: "field grid" }
const _hoisted_15 = { class: "col-12 gap-2 d-flex flex-wrap" }
const _hoisted_16 = { class: "flex justify-content-center mt-3" }

import { computed, inject, onBeforeMount, reactive, ref } from "vue";
import { get, set } from "@vueuse/core";
import { useRoute } from "vue-router";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { ValidateError } from "async-validator";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import rules from "./rules";
import * as _ from "lodash";
import { Quill, QuillEditor } from "@vueup/vue-quill";
import EmojiPicker from "vue3-emoji-picker";
import "../../../../../node_modules/vue3-emoji-picker/dist/style.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { LineNotificationMessageServices } from "@/clinic/services";
import type { ApiLineNotificationMessageReq } from "@/clinic/typings";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import { GROUP_NAMES_EMOJI, PLACEHOLDER_EMOJI } from "@/clinic/typings/constants/clinic";
import {
  MenuOptionNotificationLineConstants,
  MessageTypeNotificationLineConstants,
  NotificationLineConstants,
} from "@/clinic/constants/notification.line.constants";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import LineNotificationUtils from "@/clinic/utils/line-notification-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  setup(__props) {

const route = useRoute();
const toast = useToast();

const clinicId = ref(0);
const formRef = ref<HTMLFormElement>();
const pass = ref(false);
const emojiOnShow = ref(false);
const emojiPickerWrapper = ref();
const errorFields = ref<{ [key: string]: ValidateError | ValidateError[] }>();
const errors = ref<ValidateError[]>([]);
const formObject = reactive({
  id: 0,
  clinic_id: 0,
  title: "",
  body: "",
  message_type: "created",
  number_medical_option: 5,
});

const options = {
  placeholder: "メッセージを入力",
  clipboard: {
    matchVisual: false,
    breaks: "single",
  },
};

const showEmoji = () => {
  emojiOnShow.value = !emojiOnShow.value;
};

let Embed = Quill.import("blots/embed");

class QuillHashtag extends Embed {
  static create(value) {
    let node = super.create();
    if (value) {
      node.setAttribute("data-tag", value);
      node.setAttribute("class", "quill-hashtag");
      node.setAttribute("contenteditable", false);
      node.innerText = value;
    }
    return node;
  }

  static formats(domNode) {
    return domNode.getAttribute("class");
  }
}

QuillHashtag.blotName = "hashtag";
QuillHashtag.tagName = "span";
Quill.register({
  "formats/hashtag": QuillHashtag,
});

const editor = ref();

const onSelectEmoji = emoji => {
  const quill = get(editor).getQuill();
  const selection = quill.getSelection(true);
  quill.insertText(selection.index, emoji.i);
};

const addTag = tag => {
  const quill = get(editor).getQuill();
  const selection = quill.getSelection(true);
  quill.insertEmbed(selection.index, "hashtag", tag);
};

const initValidation = computed(() => {
  return useAsyncValidator(formObject, rules);
});

const validate = async () => {
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();

  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));

  return fPass;
};

const backToList = () => {
  RouterUtils.goTo(RouterConstants.LINE_NOTIFICATION_MESSAGE_ROUTER_NAME);
};

const saveTemplate = async () => {
  if (!(await validate())) {
    return;
  }
  const saveFormObject = { ...formObject };
  saveFormObject.body = LineNotificationUtils.contentToHtml(formObject.body);
  await LineNotificationMessageServices.saveTemplate(
    saveFormObject,
    () => RouterUtils.goTo(RouterConstants.LINE_NOTIFICATION_MESSAGE_ROUTER_NAME),
    () => {
      notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
    }
  );
};

const handleDocumentClick = (event: Event) => {
  if (emojiOnShow.value && emojiPickerWrapper.value && !emojiPickerWrapper.value.contains(event.target)) {
    emojiOnShow.value = false;
  }
};

onBeforeMount(async () => {
  document.addEventListener("click", handleDocumentClick);
  await set(clinicId, await inject("clinicId"));
  Object.assign(formObject, { clinic_id: get(await get(clinicId)) });
  const { params } = route;
  if (params.id) {
    const { data } = await LineNotificationMessageServices.fetchTemplate(
      { ...{ clinic_id: get(await get(clinicId)) }, ...{ id: params.id } } as ApiLineNotificationMessageReq,
      () => undefined,
      () => undefined
    );
    const { id, clinic_id, title, body_html, message_type } = data.value;
    Object.assign(formObject, {
      id,
      clinic_id,
      title,
      body: body_html,
      message_type,
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      ref_key: "formRef",
      ref: formRef
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_InputText, {
            id: "title",
            class: _normalizeClass(["w-full", { 'p-invalid': errorFields.value?.title }]),
            placeholder: "タイトルを入力",
            modelValue: formObject.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formObject.title) = $event))
          }, null, 8, ["modelValue", "class"]),
          _hoisted_5,
          (errorFields.value?.title)
            ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_.head(errorFields.value.title)?.message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(Dropdown), {
            modelValue: formObject.message_type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formObject.message_type) = $event)),
            options: _unref(MessageTypeNotificationLineConstants),
            optionLabel: "message_type_title",
            optionValue: "value",
            placeholder: "メッセージタイプ選択",
            class: "w-full md:w-[14rem]"
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(QuillEditor), {
            id: "quill-editor",
            ref_key: "editor",
            ref: editor,
            content: formObject.body,
            "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((formObject.body) = $event)),
            contentType: "html",
            options: options
          }, null, 8, ["content"]),
          (errorFields.value?.body)
            ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_.head(errorFields.value.body)?.message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "emoji-picker-wrapper w-auto relative",
            ref_key: "emojiPickerWrapper",
            ref: emojiPickerWrapper
          }, [
            _createVNode(_component_Button, {
              class: "p-button p-component p-button-light",
              label: "絵文字",
              onClick: showEmoji
            }),
            _createVNode(_unref(EmojiPicker), {
              onSelect: onSelectEmoji,
              class: _normalizeClass(["absolute emoji-picker", { hidden: !emojiOnShow.value }]),
              "group-names": _unref(GROUP_NAMES_EMOJI),
              native: true,
              "static-texts": _unref(PLACEHOLDER_EMOJI)
            }, null, 8, ["class", "group-names", "static-texts"])
          ], 512),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(NotificationLineConstants), (value, key) => {
            return (_openBlock(), _createBlock(_component_Button, {
              class: "p-button p-component p-button-light",
              label: value,
              key: key,
              onClick: ($event: any) => (addTag(value))
            }, null, 8, ["label", "onClick"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formObject.number_medical_option, (index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MenuOptionNotificationLineConstants), (value, key_option) => {
                return (_openBlock(), _createBlock(_component_Button, {
                  class: "p-button p-component p-button-light mr-2",
                  label: value + ' ' + index,
                  onClick: ($event: any) => (addTag(value + ' ' + index)),
                  key: key_option
                }, null, 8, ["label", "onClick"]))
              }), 128))
            ], 64))
          }), 128))
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_Button, {
        class: "p-button p-component p-button-light w-12rem mr-5",
        label: "キャンセル",
        onClick: backToList
      }),
      _createVNode(_component_Button, {
        class: "p-button p-component btn-orange w-12rem text-white",
        label: "保存",
        onClick: saveTemplate
      })
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})